import { HeadingThree, Section, Button, Paragraph, maxWidth } from 'hui';
import React from 'react';
import styled from 'styled-components';
import { supo } from '../../api';

export interface PopularCategoriesProps {
  categories?: { key: string; name: string }[];
  primaryCategory?: { key: string; name: string };
  setModalData: any;
}

const Wrap = styled.div`
  text-align: left;
`;

const ButtonBox = styled.div`
  display: inline-block;
  width: 50%;
  padding: 0.5rem 1rem;
  ${maxWidth('lg')} {
    padding: 0.5rem;
  }
`;

const ParagraphWrap = styled.div`
  padding-top: 1rem;
`;

const Center = styled.div`
  max-width: 578px;
  text-align: center;
  display: block;
  margin: 0 auto;
  padding: 3rem 0;
  ${maxWidth('lg')} {
    padding: 3rem 0.5rem;
  }
`;

const popularCategories = [
  { key: 'plumbers', name: 'Plumbers' },
  { key: 'home_cleaners', name: 'Cleaners' },
  { key: 'electricians', name: 'Electricians' },
  { key: 'builders', name: 'Builders' },
  { key: 'garden_maintenance', name: 'Gardeners' },
  { key: 'painters', name: 'Painters' },
  { key: 'lighting', name: 'Lighting' },
  { key: 'handyman', name: 'Handyman' }
];

const getModalDataFromKey = async (key: string) => {
  try {
    const response = await supo.get(`/category-questions/${key.toLowerCase()}`);
    return response.data;
  } catch (e) {
    return { categoryDetails: {}, questions: {} };
  }
};

const PopularCategories: React.SFC<PopularCategoriesProps> = ({
  setModalData,
  categories = popularCategories,
  primaryCategory
}) => {
  const openModalWithData = async (category: string) => {
    const { categoryDetails, questions } = await getModalDataFromKey(category);
    setModalData({
      categoryDetails: categoryDetails,
      questions,
      isOpen: true
    });
  };

  return (
    <Section>
      <Center>
        <HeadingThree>
          {primaryCategory
            ? `People also needed ${primaryCategory.name}`
            : `Some of our popular categories`}
        </HeadingThree>
        {primaryCategory && (
          <>
            <ButtonBox key="test">
              <Button
                color="primary"
                onClick={() => {
                  openModalWithData(primaryCategory.key);
                }}
                key={primaryCategory.key}
                block
              >
                {primaryCategory.name}
              </Button>
            </ButtonBox>
            <ParagraphWrap>
              <Paragraph>You might find these tradies useful too:</Paragraph>
            </ParagraphWrap>
          </>
        )}
        <Wrap>
          {categories.map(({ key, name }) => (
            <ButtonBox key={name}>
              <Button
                ghost
                onClick={() => {
                  openModalWithData(key);
                }}
                key={key}
                block
              >
                {name}
              </Button>
            </ButtonBox>
          ))}
        </Wrap>
      </Center>
    </Section>
  );
};

export default PopularCategories;
